var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"interval bg-color dark:bg-black z-30 px-20",style:('width:'+_vm.width+'px;')},[_c('div',{staticClass:"text-center text-lg pt-64"},[_c('UpgradePrompt')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }